import React, { Component } from "react";
import Editor from "../../../common/Quill";
import { getAnswers, getQuestion, removeAnswer } from "../../../../services/formService";
import { toast, ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import { checkImgSize } from "../../../common/commonFuncs";
import * as Icon from "react-feather";
import { logActivity } from '../../../../services/utilService';
import QAFooter from "./QAFooter";

class TypeMultiChoice extends Component {
    
  constructor(props) {
    super(props);
    this.state = {
      Question_ID: this.props.Question_ID,
      Question_Answers: [],
      Allow_Multiple_Selection: false,
      Widget_ID: this.props.Widget_ID,
      origStates: {
        Question_Answers: [],
        Allow_Multiple_Selection: false
      }
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    let { data: Question_Answers } = await getAnswers(this.state.Question_ID), 
        {data: Question_Config} = await getQuestion(this.state.Widget_ID)
    this.setState({
      ...this.state,
      Question_Answers: Question_Answers,
      Allow_Multiple_Selection: Question_Config.length > 0 ? Question_Config[0].Allow_Multiple_Selection : false,
      origStates: {
        Question_Answers: JSON.parse(JSON.stringify(Question_Answers)), // deep copy
        Allow_Multiple_Selection: Question_Config.length > 0 ? Question_Config[0].Allow_Multiple_Selection : false,
      }
    });

    // disable re-map responses if this is a newly created widget that has not been saved yet
    if (Question_Answers.length === 0) this.props.setRemapResponses(false);
  }

  async handleSave() {
    if (this.state.Question_Answers.length >= 2) {
      const Question_ID = await this.props.onSave(this.state.Question_Answers);
      this.setState({
        Question_ID,
        origStates: {
          Question_Answers: JSON.parse(JSON.stringify(this.state.Question_Answers)), // deep copy
          Allow_Multiple_Selection: this.state.Allow_Multiple_Selection
        }
      });
      logActivity('/formBuilder','WIDGET_MCQUESTION_SAVE_SUCCESS');
    }
    else {
      toaster('error', 'Please correct fields before saving')
      logActivity('/formBuilder','WIDGET_MCQUESTION_SAVE_FAILED');
    }
  }

  handleRemove() {
    this.props.onRemove();
  }

  /**
   * Allow re-mapping responses if answers and MC type have NOT been changed from what is currently saved.
   * @returns {boolean} True if allowed, False otherwise
   */
   verifyRemapResponses = () => {
     const origStates = this.state.origStates;

     // check MC type change
     if (origStates.Allow_Multiple_Selection !== this.state.Allow_Multiple_Selection) return false;

     // check answers change
     const Question_Answers = this.state.Question_Answers;
     if (origStates.Question_Answers.length !== Question_Answers.length) return false;
     for (let i = 0; i < Question_Answers.length; i++) {
       if (origStates.Question_Answers[i].Answer_Text !== Question_Answers[i].Answer_Text)
         return false;
     }
     return true;
   }

  handleAnswerChange = (text, index) => {
    const Question_Answers = [...this.state.Question_Answers];
    if (!checkImgSize(text)) {
      toaster('error', 'Image file size cannot exceed 1MB.', { position: toast.POSITION.TOP_CENTER });
    } else {
      Question_Answers[index]["Answer_Text"] = text;
    }
    this.setState({ Question_Answers });
  };

  handleAnswerRemove = async (index) => {
    const answer = this.state.Question_Answers[index];
    const { data } = await removeAnswer(answer.Answer_ID);
    if (data.includes("Done")) {
      const Question_Answers = [...this.state.Question_Answers];
      Question_Answers.splice(index, 1);
      this.setState({ Question_Answers });
      toaster('success', 'Answer removed');
      logActivity('/formBuilder','WIDGET_ANSWER_DELETE_SUCCESS');
    } else {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_ANSWER_DELETE_FAILED');
    }
  };

  handleAnswerAdd = () => {
    const Question_Answers = [...this.state.Question_Answers, { Answer_ID: 0, Answer_Text: "" }];
    this.setState({ Question_Answers });
  };

  handleQuestionType = async (Allow_Multiple_Selection) => {
    const { onMultipleSelection } = this.props;
		onMultipleSelection(Allow_Multiple_Selection);
    this.setState({ ...this.state, Allow_Multiple_Selection });
  };

  render() {
    let { Question_ID, Question_Answers } = this.state;
    return (
      <React.Fragment>
        {/* Single or Multi Selection option */}
        <div>
          <div className='form-check form-check-inline'>
            <input
              type='radio'
              className='form-check-input'
              id={Question_ID + 'single_selection'}
              name={Question_ID + 'MCType'}
              value='single'
              checked={!this.state.Allow_Multiple_Selection}
              onChange={(e) => this.handleQuestionType(false)}
            />
            <label htmlFor='single_selection' className='form-check-label'>
              Single selection
            </label>
          </div>

          <div className='form-check form-check-inline'>
            <input
              type='radio'
              className='form-check-input'
              id={Question_ID + 'multiple_selection'}
              name={Question_ID + 'MCType'}
              value='multiple'
              checked={this.state.Allow_Multiple_Selection}
              onChange={(e) => this.handleQuestionType(true)}
            />
            <label htmlFor='multiple_selection' className='form-check-label'>
              Allow multiple selection
            </label>
          </div>
        </div>

        <div>
          <label>Question Answers</label>
          {Question_Answers.map((row, idx) => {
            return (
              <div className="form-row" key={idx}>
                <div className="form-group col-md-1">{idx + 1}.</div>
                <div className="form-group col-md-10">
                  <Editor
                    value={row.Answer_Text}
                    onChange={(value) => this.handleAnswerChange(value, idx)}
                  />
                </div>

                <div className="form-group col-md-1">
                  {Question_Answers.length !== 1 && (
                    <button
                      className="btn btn-outline-warning btn-sm"
                      onClick={() => this.handleAnswerRemove(idx)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            );
          })}
          <div className="text-center mt-1">
            <button
              className="btn btn-outline-primary btn-icon btn-sm"
              onClick={this.handleAnswerAdd}
            >
              <Icon.Plus size={18} />
            </button>
          </div>
        </div>

        <QAFooter Widget_ID={this.props.Widget_ID}
                  handleSave={this.handleSave}
                  handleRemove={this.handleRemove}
                  showRemapResponses={true}
                  remapResponses={this.props.remapResponses}
                  setRemapResponses={this.props.setRemapResponses}
                  verifyRemapResponses={this.verifyRemapResponses}/>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default TypeMultiChoice;
